module.exports = __webpack_public_path__ + "static/img/watertank--small.5342dbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/corridor/watertank--small.svg
// module id = 164
// module chunks = 2